// @ts-ignore
import Lang from 'vue-lang'

// @ts-ignore
import { pathOr } from 'ramda'

const appLangs = {
  install(Vue: any, options: any) {
    let moduleLangs = {}
    if ('modules' in options) {
      moduleLangs = options['modules'].reduce((prev: any, module: string) => {

          try {
            const moduleFaLang = require(`@/modules/${module}/locale/${process.env.VUE_APP_PROJECT_NAME}.json`) 
            const fa = require(`@/modules/${module}/locale/fa.json`);
            const en = require(`@/modules/${module}/locale/en.json`);
            return {
              fa: { ...prev.fa,...fa,...moduleFaLang},
              en: {...en}
            }

          } catch (err) {
            return prev
          }
        } ,moduleLangs);
    }

    const globalFa = require("@/locale/fa.json")
    const globalmodule = require(`@/locale/${process.env.VUE_APP_PROJECT_NAME}.json`)
    const globalEn = require("@/locale/en.json")
    const moduleFa = pathOr({}, ['fa'], moduleLangs);
    const moduleEn = pathOr({}, ['en'], moduleLangs);

    const locales = {
      "fa": {...globalFa, ...moduleFa,...globalmodule},
      "en": {...globalEn, ...moduleEn}
    }

    Vue.use(Lang, {
      lang: 'fa',
      locales: locales
    });
    
  }
}
export default appLangs;
